
<script>
    export default {
        template: `

        <div v-show="isActive"><slot></slot></div>

    `,

        props: {
            name: { required: true },
            selected: { default: false}
        },

        data() {

            return {
                isActive: false
            };

        },

        computed: {

            href() {
                return '#' + this.name.toLowerCase().replace(/ /g, '-');
            }
        },

        mounted() {

            this.isActive = this.selected;

        }
    }

</script>
<style scoped>
    body { padding-top: 40px; }
</style>